// extracted by mini-css-extract-plugin
export default {"warningCard":"MaxScore__warningCard___kSQjR"};